export enum GreenhouseWebhookActionEnum {
  DeleteApplication = "delete_application",
  ApplicationUpdated = "application_updated",
  NewCandidateApplication = "new_candidate_application",
  RejectCandidate = "reject_candidate",
  UnrejectCandidate = "unreject_candidate",
  UpdateCandidate = "update_candidate",
  DeleteCandidate = "delete_candidate",
  MergeCandidate = "merge_candidate",
  HireCandidate = "hire_candidate",
  CandidateStageChange = "candidate_stage_change",
  UnhireCandidate = "unhire_candidate",
  JobCreated = "job_created",
  JobDeleted = "job_deleted",
  JobUpdated = "job_updated",
  JobApproved = "job_approved",
  JobPostCreated = "job_post_created",
  JobPostUpdated = "job_post_updated",
  JobPostDeleted = "job_post_deleted",
  JobInterviewStageDeleted = "job_interview_stage_deleted",
  InterviewDeleted = "interview_deleted",
  ScorecardDeleted = "scorecard_deleted",
  NewProspectApplication = "new_prospect_application",
  DepartmentDeleted = "department_deleted",
  OfficeDeleted = "office_deleted",
  OfferCreated = "offer_created",
  OfferUpdated = "offer_updated",
  OfferDeleted = "offer_deleted",
}
